import { ReactElement, ReactNode } from 'react'
import { ContentCopy, ContentPaste } from '@mui/icons-material'
import { Box, Stack } from '@mui/material'
import { TooltipIconButton } from '@ui/feedback'
import { PointManipulationConfig } from '../types'
import DefaultReplaceNumDecimalRoundingAction from './DefaultReplaceNumDecimalRoundingAction'

interface CoordinatePointInputActionBarProps {
  pointManipulation: PointManipulationConfig
  editable: boolean
  onCopy: () => void
  onPaste: () => void
  actions?: ReactNode
}

const CoordinatePointInputActionBar = ({
  pointManipulation,
  editable,
  onCopy,
  onPaste,
  actions,
}: CoordinatePointInputActionBarProps): ReactElement => {
  return (
    <Stack direction="row" spacing={1} padding={0} alignItems="center">
      <Box sx={{ width: '18px', height: '18px' }}> </Box>
      <TooltipIconButton
        tooltip="Kopieren"
        onClick={onCopy}
        size="small"
        tooltipProps={{ placement: 'bottom' }}
        sx={{ padding: 0 }}
      >
        <ContentCopy fontSize="small" />
      </TooltipIconButton>
      {editable && (
        <TooltipIconButton
          tooltip="Einfügen"
          onClick={onPaste}
          size="small"
          tooltipProps={{ placement: 'bottom' }}
          sx={{ padding: 0 }}
        >
          <ContentPaste fontSize="small" />
        </TooltipIconButton>
      )}
      {editable && <DefaultReplaceNumDecimalRoundingAction pointManipulation={pointManipulation} />}
      {actions}
    </Stack>
  )
}

export default CoordinatePointInputActionBar
